import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createListItemNode, $createListNode } from '@lexical/list';
import { $insertNodes } from 'lexical';
import { $createTicketNode } from './TicketNode';
import { InsertTicketData } from './types';

/**
 * Hook to insert tickets as TicketNodes in a bullet list.
 * Each ticket becomes a list item with a TicketNode inside.
 */
export function useInsertTicketList() {
  const [editor] = useLexicalComposerContext();

  return (ticketsData: InsertTicketData | InsertTicketData[]) => {
    const ticketsArray = Array.isArray(ticketsData)
      ? ticketsData
      : [ticketsData];

    editor.update(() => {
      // Create list node
      const listNode = $createListNode('bullet');

      // Create list items with TicketNodes for each ticket
      ticketsArray.forEach((ticketData) => {
        const listItemNode = $createListItemNode();

        // Create TicketNode
        const ticketId = ticketData.number?.toString() || ticketData.id;
        const ticketNode = $createTicketNode(
          ticketId,
          ticketData.showTitle ?? true,
        );

        // Append TicketNode to list item
        listItemNode.append(ticketNode);

        // Append list item to list
        listNode.append(listItemNode);
      });

      // Insert the list at the current selection (or at the end if no selection)
      $insertNodes([listNode]);

      // Move selection to after the inserted list
      listNode.selectEnd();
    });
  };
}
